import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { getMediaUrl } from '../../services/api';
import './GallerySection.css';

const GallerySection = ({ section }) => {
  const [galleries, setGalleries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadGalleries();
  }, []);

  const loadGalleries = async () => {
    try {
      const response = await api.get('/gallery/', { params: { page_size: 4 } });
      const galleryData = response.data.results || response.data;
      setGalleries(Array.isArray(galleryData) ? galleryData : []);
    } catch (error) {
      console.error('Error loading galleries:', error);
      setGalleries([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="gallery-section homepage-section">
        <Container>
          <h2 className="section-title">{section.title}</h2>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </section>
    );
  }

  if (galleries.length === 0) return null;

  return (
    <section className="gallery-section homepage-section">
      <Container>
        <h2 className="section-title">{section.title}</h2>
        <Row className={galleries.length < 4 ? 'justify-content-center' : ''}>
          {galleries.map(gallery => (
            <Col key={gallery.id} lg={3} md={6} sm={6} xs={12}>
              <Link to={`/gallery/${gallery.slug}`} className="gallery-item">
                <div 
                  className="gallery-thumbnail"
                  style={{ 
                    backgroundImage: gallery.cover_image 
                      ? `url(${getMediaUrl(gallery.cover_image)})` 
                      : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                  }}
                >
                  <div className="gallery-overlay">
                    <h5>{gallery.title}</h5>
                    <p>
                      <i className="fas fa-images me-2"></i>
                      {gallery.images_count} Photos
                    </p>
                  </div>
                </div>
              </Link>
            </Col>
          ))}
        </Row>
        <div className="text-center mt-4">
          <Link to="/gallery" className="btn btn-primary">
            View All Galleries <i className="fas fa-arrow-right ms-2"></i>
          </Link>
        </div>
      </Container>
    </section>
  );
};

export default GallerySection;
